// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-b75768a4] {\n  overflow-x: auto;\n}\n.container-active[data-v-b75768a4] {\n  overflow-x: none;\n}", ""]);
// Exports
module.exports = exports;
